import React from 'react';
import Axios from 'axios';
import moment from 'moment';
import {Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap';


class LocationEditModal extends React.Component {

  constructor(props) {
		super(props);

		this.state = {
			location: this.props.modalLocation,
		};

		this.handleInputChg = this.handleInputChg.bind(this);
		this.handleSaveLocation = this.handleSaveLocation.bind(this);
	}

	componentDidMount() {
		// console.log('LocationEditModal: componentDidMount');
		this.initModalState(this.props);
	}

	UNSAFE_componentWillReceiveProps(nextProps) {
		// console.log('LocationEditModal: UNSAFE_componentWillReceiveProps');
		this.initModalState(nextProps);
	}

	initModalState(props) {
		this.setState({
			location: props.modalLocation,
			disableSubmit: false
		});
	}

	render() {
		//console.log('LocationEditModal: render');
		//console.log(this.props.modalLocation);
		//console.log(this.state);
		var location = this.state.location;
		var addEditText = "Ajout";
		if (location._id !== "0") {
			addEditText = "Modification";
		}

		return (
    	<Modal 
  			isOpen={this.props.showModal} 
    		//toggle={this.props.handleModalCancel}		// when clicking outside the modal
				size={"sm"}
    		className={this.props.className}>

        <form className="form-horizontal" onSubmit={this.handleSaveLocation}>
    		<ModalHeader>
    			{/* toggle={this.props.handleModalCancel}> displays a small X in header */}
    			Lieu<br/>{addEditText}
    		</ModalHeader>

    		<ModalBody>
					{this.dispForm()}
    		</ModalBody>

    		<ModalFooter>
      		<button type="button" className="btn btn-secondary btn-sm stdCommandButton2" 
      			onClick={this.props.handleModalCancel}> Annuler
      		</button>
      		<button type="submit" className="btn btn-primary btn-sm stdCommandButton2"> 
      			Enregistrer
      		</button>
    		</ModalFooter>
    		</form>
    	</Modal>
    )
	}

	dispForm() {
		var location = this.state.location;
		return (
			<div>
        <div className="row row-margin-bottom-10">
        <div className="col-12">
					<span className="small"> Nom </span> <br/>
          <input className="form-control form-control-sm" type="text" id="name" 
          	value={location.name || ''}
            onChange={this.handleInputChg}></input>
				</div>
				</div>

        <div className="row row-margin-bottom-10">
        <div className="col-12">
					<span className="small"> Adresse </span> <br/>
          <input className="form-control form-control-sm" type="text" id="address" 
          	value={location.address || ''}
            onChange={this.handleInputChg}></input>
				</div>
				</div>

        <div className="row row-margin-bottom-10">
        <div className="col-12">
					<span className="small"> Téléphone </span> <br/>
          <input className="form-control form-control-sm" type="text" id="tel" 
          	value={location.tel || ''}
            onChange={this.handleInputChg}></input>
				</div>
				</div>

        <div className="row row-margin-bottom-10">
        <div className="col-12">
					<span className="small"> Lien Google Map </span> <br/>
          <input className="form-control form-control-sm" type="text" id="googlemap" 
          	value={location.googlemap || ''}
            onChange={this.handleInputChg}></input>
				</div>
				</div>

        <div className="row row-margin-bottom-10">
        <div className="col-12">
					<span className="small"> Surfaces </span> <br/>
					<span className="small"><i> (grandeur (nombre), grandeur (nombre), ...) </i></span> <br/>
          <input className="form-control form-control-sm" id="surfaces" 
          	value={location.surfaces || ''}
          	onChange={this.handleInputChg}></input>
				</div>
				</div>
			</div>
		)
	}

	handleInputChg(e) {
		var location = this.state.location;
		location[e.target.id] = e.target.value;
		this.setState({	location: location });
	}

	handleSaveLocation(e) {
		//console.log('handleSaveLocation !');
		e.preventDefault();

		if (this.state.disableSubmit) {
			return;
		}

		var _this = this;
		var location = this.state.location;
		location.surfaces = location.surfaces.split(',').map(sf => (sf.trim()));		// convert to array
		location.surfaces = location.surfaces.map(sf => {
			var surfaces = {type: 'err', nb: 0};

			if (sf.split(' ').length > 1) {
				surfaces = {	
					type: sf.split(' ')[0], 
					nb: parseInt(sf.split(' ')[1].replace('(','').replace(')',''))
				}
			}
			return surfaces;
		});

		// Validation
		if ((location.name === '') || (location.address === '') || (location.tel === '') || 
			  (location.googlemap === '') || (location.surfaces === ''))	{
			alert('Vous devez spéficier tous les champs');

		} else {
			_this.setState({
				disableSubmit: true
			});

			// Post operation
			Axios.post('/api/locations/saveLocation', {
				locationObj: location,
			})
			.then(function(response) {
				_this.props.reloadData();
				
				_this.props.handleModalCancel();
			})
			.catch(function(error) {
				console.log('ERROR');
				console.log(error);
				_this.props.handleModalCancel();
			});
		}

	}

	isNumeric(n) {
		// not good for negative values
		return !isNaN(parseFloat(n)) && isFinite(n);
	}

}

export default LocationEditModal;